import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeRoutes } from 'utils/navigationHelpers';
import { Routes } from 'react-router-dom';
import { AppContainer } from './styles';
import { withTheme } from 'styled-components';
import { FovMessages } from 'components';
import { removeMessage } from 'store/actions/appActions';
import constants from 'constants';

const { JOB_PHASES } = constants;

const App = withTheme(props => {
  const { theme } = props;
  const dispatch = useDispatch();
  const token = true;
  const appStore = useSelector(state => state.app);
  const jobStore = useSelector(state => state.job);
  const selectedTheme = appStore.theme;
  // The status page owns the viewport while it is up, so nothing stacks on it.
  const statusPageVisible = jobStore.phase !== JOB_PHASES.IDLE;

  const removeMessageById = useCallback(payload => {
    dispatch(removeMessage(payload));
  }, [ dispatch ]);

  return (
    <AppContainer theme={theme} $selectedTheme={selectedTheme}>
      <Routes>
        {makeRoutes(token)}
      </Routes>

      {!statusPageVisible && (
        <FovMessages
          messages={appStore.messages}
          removeMessage={removeMessageById}
        />
      )}
    </AppContainer>
  );
});

export { App };